import React, {Component} from 'react'
import PropTypes from 'prop-types'
import timeHuman from "../../../../../helpers/time/timeHuman"
import {_countResultsToday} from "../../../../../services/apis/KeywordServices"

class Keyword extends Component {
    state = {
        count: 0
    }

    _refresh = null
    _timeout = null
    _refreshTime = 60000

    componentDidMount() {
        this._fetchCount()

        const timeout = (this.props.order - 1) * 500

        this._timeout = setTimeout(() => {
            this._refresh = setInterval(async () => {
                await this._fetchCount()
            }, this._refreshTime)
        }, timeout)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
        this._timeout && clearTimeout(this._timeout)
    }

    _fetchCount = async () => {
        const {keyword, onCountTotal} = this.props
        const {success, data} = await _countResultsToday(keyword._id)

        if (success) {
            const total = parseInt(data, 10)

            this.setState({
                count: total
            })

            typeof onCountTotal === 'function' && onCountTotal(keyword._id, total)
        }
    }

    _handleRemoveKeyword = e => {
        e.preventDefault()

        this.props.onRemove(this.props.keyword._id)
    }

    render() {
        const {keyword, order} = this.props
        const {term, status, lastActiveTime} = keyword
        const {count} = this.state

        const activeTimeText = lastActiveTime ? timeHuman(lastActiveTime, 'DD/M H:mm:ss') : 'None'

        return (
            <tr className="Keyword">
                <td className="Order">{order}</td>
                <td className="Term">{term}</td>
                <td className="Count">{count}</td>
                <td className="Status">{status}</td>
                <td className="ActiveTime">{activeTimeText}</td>
                <td className="Actions">
                    <button className='btn btn-danger' onClick={this._handleRemoveKeyword}>
                        <i className="fas fa-times"/>
                    </button>
                </td>
            </tr>
        )
    }
}

Keyword.propTypes = {
    keyword: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired,
    onCountTotal: PropTypes.func,
}

export default Keyword



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/Keyword.js